export type SiteConnectionInput = {
  collectorMode?: string;
  lastObservedAt?: string | null;
  managedCollectorHealth?: string;
};

export type SiteConnectionState = "connected" | "waiting" | "stale" | "paused" | "error" | "degraded";

const STALE_AFTER_MS = 7 * 24 * 60 * 60_000;

export function siteConnectionState(site: SiteConnectionInput, nowMs = Date.now()): SiteConnectionState {
  if (site.collectorMode === "disabled") return "paused";
  if (site.managedCollectorHealth === "resolver_error") return "error";
  if (site.managedCollectorHealth === "resolver_degraded") return "degraded";
  const lastObservedMs = new Date(site.lastObservedAt ?? "").getTime();
  if (!Number.isFinite(lastObservedMs)) return "waiting";
  if (nowMs - lastObservedMs > STALE_AFTER_MS) return "stale";
  return "connected";
}

export function siteConnectionTone(state: SiteConnectionState): "success" | "warning" | "danger" | "neutral" {
  if (state === "connected") return "success";
  if (state === "error") return "danger";
  if (state === "waiting") return "neutral";
  return "warning";
}

/**
 * The one plain status customers see for a website. Internal setup states
 * (collector mode, verification summary, comparison gates) never reach this copy.
 */
export const siteConnectionCopy: Record<SiteConnectionState, { label: string; description: string }> = {
  connected: { label: "Verbunden", description: "Moonshot empfängt Daten von dieser Website." },
  waiting: { label: "Wartet auf erste Daten", description: "Sobald die Website mit eingebautem Tag aufgerufen wird, erscheint hier die Verbindung." },
  stale: { label: "Prüfen", description: "Seit mehr als sieben Tagen sind keine Daten eingetroffen. Ist der Tag noch eingebaut?" },
  degraded: { label: "Eingeschränkt", description: "Daten kommen an, die Firmenerkennung ist aber gerade eingeschränkt. Hält das an, kontaktiere bitte den Support." },
  paused: { label: "Pausiert", description: "Die Datenerfassung für diese Website ist pausiert." },
  error: { label: "Störung", description: "Daten kommen an, aber die Verarbeitung meldet einen Fehler. Bitte kontaktiere den Support." }
};
